import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';

export const EPSG_4326 = '+proj=longlat +datum=WGS84 +no_defs';
export const ETRS_89 = '+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs'

const projections = {
    'EPSG:4326': EPSG_4326,
    'EPSG:25830': ETRS_89,
  }

export const registerProjections = () => {
  Object.entries(projections).forEach(([code, def]) => {    
    proj4.defs(code, def);
  });
  register(proj4);
};
